<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="false"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{ alertMessage }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">期間指定</p>
          </div>
          <div class="col-6 mb-2">
            <div class="input-group">
              <input
                type="month"
                class="form-control"
                v-model="sprm.startMonth"
                placeholder="開始年月"
              />
              <span class="input-group-text">～</span>
              <input
                type="month"
                class="form-control"
                v-model="sprm.endMonth"
                placeholder="終了年月"
              />
            </div>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">年度</p>
          </div>
          <div class="col-6 mb-2">
            <bs-select
              :options="yearOptions"
              v-model="sprm.sportsYear"
              :null-option="true"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button :btnClass="'btn-primary'" @to_click_event="searchSales"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clearSearch"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="w100" v-if="isDataLoaded">
      <h5>検索結果概要</h5>
      <div class="card mb-4">
        <div class="card-header bg-light">
          <div class="d-flex justify-content-between align-items-center">
            <span>検索結果: 全{{ totalCount }}件</span>
            <span>合計金額: {{ Number(totalAmount).toLocaleString() }}円</span>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-striped table-hover mb-0">
              <thead class="table-light">
                <tr>
                  <th>売上ID</th>
                  <th>日付</th>
                  <th>年度</th>
                  <th>金額</th>
                  <th>商品数</th>
                  <th>決済方法</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in displayedResults" :key="index">
                  <td>{{ item.id }}</td>
                  <td>{{ item.sales_date }}</td>
                  <td>{{ item.sports_year }}年度</td>
                  <td>{{ Number(item.payment_value).toLocaleString() }}円</td>
                  <td>
                    {{ item.sales_orders ? item.sales_orders.length : 0 }}点
                  </td>
                  <td>{{ formattedChargeType(item.charge_type) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="card-footer bg-light text-center"
          v-if="
            searchResults.length > displayedResults.length || showAllResults
          "
        >
          <div>
            <small class="text-muted" v-if="!showAllResults">
              ※ 上記は最初の{{ displayedResults.length }}件のみ表示しています。
            </small>
            <button
              class="btn btn-sm btn-outline-secondary mt-2"
              @click="toggleAllResults()"
            >
              {{ showAllResults ? '表示を縮小する' : 'もっと見る' }}
              <i
                :class="
                  showAllResults ? 'fas fa-chevron-up' : 'fas fa-chevron-down'
                "
              ></i>
            </button>
          </div>
        </div>
      </div>

      <h5 v-if="chk_relation_type_editable('/sales/csv_export')">CSV出力</h5>
      <!-- CSVの説明文を追加 -->
      <div
        class="alert alert-info mb-3"
        v-if="chk_relation_type_editable('/sales/csv_export')"
      >
        <i class="fas fa-info-circle"></i> <strong>CSV出力について</strong>
        <p class="mb-1">
          上記の検索結果概要は最大10件のプレビューデータのみを表示しています。以下の3種類のCSVファイルでは、すべてのデータをダウンロードできます：
        </p>
        <ul class="mb-0">
          <li>
            <strong>売上サマリー</strong
            >：商品バリエーション毎に集計したデータです。同じ商品の売上をまとめて表示するため、全体像を把握するのに適しています。
          </li>
          <li>
            <strong>売上明細</strong
            >：個々の売上トランザクションの詳細情報です。1件の売上につき1行で表示され、すべての取引データを確認できます。
          </li>
          <li>
            <strong>FLAM用CSV</strong
            >：販売管理システムに取り込むための特殊フォーマットのデータです。外部システムとの連携に使用します。
          </li>
        </ul>
      </div>
      <div class="mb-4" v-if="chk_relation_type_editable('/sales/csv_export')">
        <table class="table table-bordered">
          <thead class="text-center">
            <tr>
              <th style="width: 33%">売上サマリー</th>
              <th style="width: 33%">売上明細</th>
              <th style="width: 33%">FLAM用CSV</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                <p>商品バリエーション毎の集計データ<br />（数量と総額）</p>
                <bs-button
                  :btnClass="'btn-primary'"
                  @to_click_event="downloadCSV('summary')"
                  :disabled="isDownloading"
                  >ダウンロード</bs-button
                >
              </td>
              <td class="text-center">
                <p>売上データの詳細情報<br />（1レコード1行）</p>
                <bs-button
                  :btnClass="'btn-primary'"
                  @to_click_event="downloadCSV('detail')"
                  :disabled="isDownloading"
                  >ダウンロード</bs-button
                >
              </td>
              <td class="text-center">
                <p>販売管理システム用<br />インポートデータ</p>
                <bs-button
                  :btnClass="'btn-primary'"
                  @to_click_event="downloadCSV('flam')"
                  :disabled="isDownloading"
                  >ダウンロード</bs-button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-if="!isDataLoaded && showNoData" class="alert alert-warning">
      <p>NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import axios from 'axios'
import config from '../../../const'
// import Common from '../../../common/common'

export default {
  name: 'SalesCsvExportView',
  components: {
    BsPageTitle,
    BsMsgAlert,
    BsSelect,
    BsButton
  },
  data() {
    return {
      fromParentTitle: '売上データCSV出力',
      fromParentBtn: '',
      alertMessage:
        '売上データCSV出力画面です。検索条件で期間を指定し、CSVをダウンロードできます。',
      alertClass: 'alert-info',
      sprm: {
        startMonth: '',
        endMonth: '',
        sportsYear: ''
      },
      isDataLoaded: false,
      isDownloading: false,
      showNoData: false,
      availableYears: [],
      searchResults: [],
      displayedResults: [], // 表示用（10件まで）
      showAllResults: false, // すべての結果を表示するかのフラグ
      totalAmount: 0,
      totalCount: 0,
      // エラーメッセージを一元管理
      messages: {
        error: {
          noToken: '認証情報が不足しています。再ログインしてください。',
          searchRequired: '期間の入力は必須です。',
          searchFailed: '検索中にエラーが発生しました。',
          downloadFailed: 'CSVのダウンロード中にエラーが発生しました。',
          noData: '指定された条件に一致するデータが見つかりませんでした。',
          yearLoadFailed: '年度データの取得に失敗しました。'
        },
        success: {
          searchComplete: count =>
            `検索が完了しました。${count}件のデータが見つかりました。CSVをダウンロードできます。`,
          downloadComplete: fileName =>
            `${fileName}のダウンロードが完了しました。`
        },
        info: {
          searching: '検索中です...',
          downloading: 'ダウンロード処理中...'
        }
      }
    }
  },
  computed: {
    ...mapState(['token']),
    yearOptions() {
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentMonth = now.getMonth() + 1
      const targetYear =
        parseInt(currentMonth) >= 12 ? currentYear + 1 : currentYear
      const years = []
      for (let y = parseInt(targetYear); y >= 2024; y--) {
        years.push({
          key: y,
          label: y + '年度'
        })
      }
      return years
      // return this.availableYears.map(year => ({
      //   key: year,
      //   label: year + '年度'
      // }))
    },
    formattedChargeType() {
      return type => {
        switch (type) {
          case 'CREDIT':
            return 'クレジット決済'
          case 'CASH':
            return 'コンビニ決済'
          default:
            return type
        }
      }
    }
  },
  mounted() {
    this.initializeForm()
    this.loadAvailableYears()
  },
  methods: {
    // 開発環境のみログを出力するヘルパー関数
    devLog(message, data) {
      if (process.env.NODE_ENV === 'development') {
        console.log(message, data)
      }
    },
    // 末日取得
    getLastDayOfMonth(yyyyMm) {
      const [year, month] = yyyyMm.split('-').map(Number)
      return new Date(year, month, 0).getDate() // 翌月の0日＝前月末日
    },
    // 日付フォーマット
    formatDate(dateStr, item) {
      // 無効または初期値の日付の場合
      if (!dateStr || dateStr === '0000-00-00' || dateStr === 'null') {
        // APIレスポンスのcharge_resultからトランザクション日時を試す
        try {
          if (
            item &&
            item.charge_result &&
            typeof item.charge_result === 'object' &&
            item.charge_result.transactionDateTime
          ) {
            const transactionDate = new Date(
              item.charge_result.transactionDateTime
            )
            if (!isNaN(transactionDate.getTime())) {
              return transactionDate.toLocaleDateString('ja-JP')
            }
          }
        } catch (e) {
          this.devLog('トランザクション日時の取得に失敗:', e)
        }

        return '-'
      }

      try {
        // 日付が年月日に含まれていない場合は月末日を設定
        if (dateStr.length === 7) {
          // YYYY-MM形式
          const [year, month] = dateStr.split('-')
          const lastDay = new Date(Number(year), Number(month), 0).getDate()
          dateStr = `${dateStr}-${lastDay}`
        }

        const date = new Date(dateStr)
        if (isNaN(date.getTime())) {
          return '-'
        }
        return date.toLocaleDateString('ja-JP')
      } catch (e) {
        this.devLog('日付フォーマットエラー:', e)
        return '-'
      }
    },

    // トランザクション日時を持っているか確認
    hasTransactionDate(item) {
      return (
        item &&
        item.charge_result &&
        item.charge_result.transactionDateTime &&
        typeof item.charge_result.transactionDateTime === 'string'
      )
    },

    // 商品数を取得
    getOrderCount(item) {
      if (!item.sales_orders || !Array.isArray(item.sales_orders)) {
        return '-'
      }
      return item.sales_orders.length
    },

    // 決済方法のフォーマット
    formatPaymentType(type) {
      const paymentTypes = {
        CREDIT: 'クレジットカード',
        KONBINI: 'コンビニ決済',
        CASH: '現金',
        WALLET: 'Pay'
      }
      return paymentTypes[type] || type || '-'
    },

    // ステータスのテキスト
    getStatusText(stat) {
      const statuses = {
        1: '有効',
        9: 'キャンセル'
      }
      return statuses[stat] || '不明'
    },

    // ステータスのクラス
    getStatusClass(stat) {
      return (
        {
          1: 'bg-success',
          9: 'bg-danger'
        }[stat] || 'bg-secondary'
      )
    },

    // 認証トークンを取得する
    getAuthToken() {
      const userTkn =
        this.token ||
        sessionStorage.getItem('token') ||
        localStorage.getItem('token')
      if (!userTkn) {
        this.alertMessage = this.messages.error.noToken
        this.alertClass = 'alert-danger'
        return null
      }
      return userTkn
    },

    initializeForm() {
      // 現在の年月を取得
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentMonth = now.getMonth() + 1

      // 今月をデフォルトの終了月に設定
      this.sprm.endMonth = `${currentYear}-${String(currentMonth).padStart(
        2,
        '0'
      )}`

      // 3ヶ月前をデフォルトの開始月に設定
      let startMonth = currentMonth - 3
      let startYear = currentYear
      if (startMonth <= 0) {
        startMonth += 12
        startYear -= 1
      }
      this.sprm.startMonth = `${startYear}-${String(startMonth).padStart(
        2,
        '0'
      )}`
    },

    async loadAvailableYears() {
      const params = {
        sprm: {
          stat: [1]
        }
      }

      await this.basicPosts_S(
        config.BASE_API_URL + '/sales_order/lists',
        params
      )
        .then(async response => {
          this.devLog('loadAvailableYears response:', response)
          if (response.data && response.data.body) {
            // sports_yearの値を抽出して重複を除去
            const years = [
              ...new Set(
                response.data.body
                  .map(item => item.sports_year)
                  .filter(year => year)
              )
            ] // nullや空値を除外
              .sort((a, b) => b - a) // 降順にソート

            this.availableYears = years
            this.devLog('取得した年度データ:', this.availableYears)
          } else {
            this.devLog('年度データが空です')
            this.availableYears = []
          }
        })
        .catch(async err => {
          this.devLog('年度データの取得に失敗しました:', err)
          this.alertMessage = this.messages.error.yearLoadFailed
          this.alertClass = 'alert-danger'
          this.availableYears = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },

    clearSearch() {
      this.sprm = {
        startMonth: '',
        endMonth: '',
        sportsYear: ''
      }
      this.isDataLoaded = false
      this.showNoData = false
      this.initializeForm()
    },

    async searchSales() {
      try {
        this.showNoData = false
        this.isDataLoaded = false
        this.showAllResults = false
        this.alertMessage = this.messages.info.searching
        this.alertClass = 'alert-info'
        this.searchResults = []
        this.displayedResults = []
        this.totalAmount = 0
        this.totalCount = 0

        // 入力チェック

        // 認証トークンを取得
        const userTkn = this.getAuthToken()
        if (!userTkn) return

        let response
        try {
          response = await axios({
            url: `${config.BASE_API_URL}/sales/lists`,
            method: 'POST',
            data: {
              sprm: {
                sales_date_lower: this.sprm.startMonth
                  ? this.sprm.startMonth + '-01 00:00:00'
                  : '',
                sales_date_higher: this.sprm.endMonth
                  ? // ? this.sprm.endMonth + '-31 23:59:59'
                    `${this.sprm.endMonth}-${this.getLastDayOfMonth(
                      this.sprm.endMonth
                    )} 23:59:59`
                  : '',
                sports_year: this.sprm.sportsYear ? this.sprm.sportsYear : '',
                stat: [1]
              },
              page: false,
              pagelimit: false
            },
            headers: {
              'Content-Type': 'application/json',
              'mfj-manage-token': userTkn
            }
          })
        } catch (apiError) {
          this.devLog('API呼び出しエラー:', apiError)
          // エラー時はresponseを初期化
          response = { data: null }
        }

        // データが存在するか確認
        let count = 0

        // APIレスポンスのチェック
        if (
          process.env.NODE_ENV === 'development' &&
          (!response.data ||
            typeof response.data === 'string' ||
            !response.data.body ||
            response.data.body.length === 0)
        ) {
          this.devLog(
            'APIからデータが取得できないため、開発環境ではサンプルデータを生成できます'
          )

          // 開発環境用のサンプルデータ生成が必要な場合はここに実装
          if (typeof response.data === 'string' || !response.data) {
            response.data = {}
          }
        }

        // 検索結果の概要を保存
        if (response.data && response.data.body) {
          this.searchResults = response.data.body

          // payment_valueの合計を計算
          this.totalAmount = this.searchResults.reduce(
            (sum, item) => sum + (Number(item.payment_value) || 0),
            0
          )

          count = response.data.all_count
            ? response.data.all_count
            : this.searchResults.length
          this.totalCount = count

          // 表示用データセットを初期化
          this.updateDisplayedResults()
        }

        // 結果の表示処理
        if (
          count > 0 ||
          (this.searchResults && this.searchResults.length > 0)
        ) {
          // 成功メッセージを表示
          this.alertMessage = `検索が完了しました。${count}件のデータが見つかりました。CSVをダウンロードできます。`
          this.alertClass = 'alert-success'
          this.isDataLoaded = true
        } else if (process.env.NODE_ENV === 'development') {
          // 開発環境ではデータがなくてもダウンロードボタンを表示
          this.alertMessage =
            '指定された条件に一致するデータが見つかりませんでしたが、開発用にダウンロードボタンを表示しています。'
          this.alertClass = 'alert-warning'
          this.showNoData = false
          this.isDataLoaded = true
        } else {
          // 本番環境でデータがない場合
          this.alertMessage = '検索結果は0件です。条件を見直してください。'
          this.alertClass = 'alert-warning'
          this.showNoData = true
          this.isDataLoaded = false
        }
      } catch (error) {
        console.error('検索エラー:', error)
        this.alertMessage =
          '検索中にエラーが発生しました。' +
          (error.response ? `ステータスコード: ${error.response.status}` : '')
        this.alertClass = 'alert-danger'
        this.showNoData = true
        this.isDataLoaded = false
      }
    },

    // CSVダウンロード用のAPIエンドポイントとファイル名を取得
    getDownloadConfig(type) {
      let endpoint = ''
      let fileName = ''

      switch (type) {
        case 'summary':
          endpoint = '/sales/output_summary_csv'
          fileName = '売上サマリー.csv'
          break
        case 'detail':
          endpoint = '/sales/output_detail_csv'
          fileName = '売上明細.csv'
          break
        case 'flam':
          endpoint = '/sales/output_flam_csv'
          fileName = 'FLAM用データ.csv'
          break
      }

      return { endpoint, fileName }
    },

    // レスポンスを処理してCSVをダウンロード
    handleCsvResponse(response, fileName) {
      // レスポンスの内容タイプを確認
      const contentType = response.headers['content-type']

      // CSVファイルの場合の判定条件
      if (
        contentType &&
        (contentType.includes('text/csv') ||
          contentType.includes('application/octet-stream'))
      ) {
        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // 成功メッセージを表示
        this.alertMessage = this.messages.success.downloadComplete(fileName)
        this.alertClass = 'alert-success'
        return true
      }

      return false
    },

    // エラーレスポンスを処理
    handleErrorResponse(response) {
      // BlobをJSONとして読み込む
      const reader = new FileReader()
      reader.onload = () => {
        try {
          const textContent = reader.result
          this.devLog(
            'レスポンステキスト:',
            textContent.substring(0, 200) + '...'
          ) // 先頭200文字をログ出力

          const errorData = JSON.parse(textContent)
          this.devLog('API Error:', errorData)
          this.alertMessage =
            errorData.message || this.messages.error.downloadFailed
          this.alertClass = 'alert-danger'
        } catch (e) {
          this.devLog('JSON解析エラー:', e)
          this.devLog('解析失敗テキスト:', reader.result.substring(0, 500))
          this.alertMessage =
            'レスポンスの解析に失敗しました。サーバーの応答が不正です。'
          this.alertClass = 'alert-danger'
        }
      }
      reader.readAsText(response.data)
    },

    async downloadCSV(type) {
      try {
        this.isDownloading = true
        this.alertMessage = this.messages.info.downloading
        this.alertClass = 'alert-info'

        // URLを設定
        const { endpoint, fileName } = this.getDownloadConfig(type)

        // 認証トークンを取得
        const userTkn = this.getAuthToken()
        if (!userTkn) {
          this.isDownloading = false
          return
        }

        // APIリクエスト
        const response = await axios({
          url: `${config.BASE_API_URL}${endpoint}`,
          method: 'POST',
          data: {
            sprm: {
              sales_date_higher: this.sprm.startMonth
                ? this.sprm.startMonth + '-01 00:00:00'
                : '',
              sales_date_lower: this.sprm.endMonth
                ? this.sprm.endMonth + '-31 23:59:59'
                : '',
              sports_year: this.sprm.sportsYear || '',
              stat: [1]
            },
            page: false,
            pagelimit: false
          },
          responseType: 'blob',
          headers: {
            'Content-Type': 'application/json',
            'mfj-manage-token': userTkn
          }
        })

        // レスポンスヘッダーのデバッグ表示（開発環境のみ）
        this.devLog('レスポンスヘッダー:', response.headers)
        this.devLog('Content-Type:', response.headers['content-type'])
        this.devLog(
          'Content-Disposition:',
          response.headers['content-disposition']
        )

        // CSVファイルの場合はダウンロード処理
        const isSuccess = this.handleCsvResponse(response, fileName)

        // エラーレスポンスの場合
        if (!isSuccess) {
          this.handleErrorResponse(response)
        }
      } catch (error) {
        this.devLog('ダウンロードエラー:', error)
        this.alertMessage =
          this.messages.error.downloadFailed +
          (error.response ? ` ステータスコード: ${error.response.status}` : '')
        this.alertClass = 'alert-danger'
      } finally {
        this.isDownloading = false
      }
    },

    // 表示する結果を更新
    updateDisplayedResults() {
      if (this.showAllResults) {
        this.displayedResults = this.searchResults
      } else {
        this.displayedResults = this.searchResults.slice(0, 10)
      }
    },

    // すべての結果を表示/非表示
    toggleAllResults() {
      this.showAllResults = !this.showAllResults
      this.updateDisplayedResults()
    }
  }
}
</script>
